import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectOfferId } from '../../../selectors/offer';
import { setE2eLabel } from '../../../services/e2eLabel';
import { useAsync } from '../../../hooks/useAsync';
import { ApplicationContext } from '../../ApplicationContext';

interface IUseSetOfferLabelProps {
  showLabel: boolean;
  onSuccess: () => void;
}

export const useSetOfferLabel = ({ showLabel, onSuccess }: IUseSetOfferLabelProps) => {
  const { httpApi, logger } = React.useContext(ApplicationContext);
  const offerId = useSelector(selectOfferId);

  const [{ status }, toggleLabel] = useAsync(async () => {
    if (!offerId) {
      throw new Error('Offer id was not found in redux store');
    }

    const res = await setE2eLabel({ httpApi, logger, parameters: { offerId, showLabel } });

    return res;
  });

  const setOfferLabel = async () => {
    if (status === 'pending') {
      return;
    }
    const res = await toggleLabel();
    if (res.status === 'success') {
      onSuccess();
    }
  };

  return {
    setOfferLabel,
    isLoading: status === 'pending',
    isError: status === 'error',
  };
};
